module.exports = __webpack_public_path__ + "img/2.a65c1105.png";